export default {
  props: {
    validation: {
      type: Object,
      default: () => ({ touched: false, anyFocus: false, $params: {} }),
    },
    label: {
      type: String,
      required: false,
    },
    labelStyle: {
      type: String,
      required: false,
    },
    labelInfo: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    helpText: {
      type: String,
      required: false,
    },
    successText: {
      type: String,
      required: false,
    },
    manualError: {
      type: String,
      default: null
    },
    hideErrors: {
      type: Boolean,
      default: false
    },
    showRequiredStar: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: null,
    },
    labelAsPlaceholder: {
      type: Boolean,
      default: false,
    },
    fillBg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { focused: null, touched: null };
  },
  computed: {
    uniqueId() {
      return `input_${this._uid}`;
    },
    required() {
      return this.validation && 'required' in this.validation;
    },
    filled() {
      return !!this.modelValue || !!this.value;
    },
    invalidField() {
      const { anyFocus, $dirty, $invalid } = this.validation;
      return (!anyFocus && $dirty && $invalid) || !!this.manualError;
    },
    computedPlaceholder() {
      return this.labelAsPlaceholder ? undefined : this.placeholder;
    }
  },
  watch: {
    value() {
      if (this.manualError) {
        this.$emit('reset-form-feedback');
      }
    }
  },
};
